import cookie from 'js-cookie';
import Vue from "vue";
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = {
    locale: cookie.get('mfs_lang') || 'zh', // 语言标识,第一次登录默认是中文
    messages: {
      zh: require('@/locales/zh-cn'), // 汉语
      en: require('@/locales/en_us'), // 英语
    }
  }
  
  let str = ''
  for (let i = 0, locale = i18n.locale; i < locale.length; i++) {
    if(i<2) {
        str = `${str}${locale[i]}`
    }
  }
//通用的枚举值
export default {
    //菜单资源管理枚举
    resourceType: {
        0: i18n.messages[str].language['5o6uyb93v000'],
        1: i18n.messages[str].language['5o6v4bolgz50'],
        2: i18n.messages[str].language['5o6v4bolgz60']
    },
    yesOrNo: {
        0: i18n.messages[str].language['5o6uj7uyta00'],
        1: i18n.messages[str].language['5o6uj7uytcs0']
    },
    highRiskType: {
        0: i18n.messages[str].language['5o6u1gm4kjhg'],
        1: i18n.messages[str].language['5o6u1gm4k4hg'],
        2: i18n.messages[str].language['5o6u1dm4kjhg'],
        3: i18n.messages[str].language['5o1u1gm4kjhg'],
        4: i18n.messages[str].language['5o6u1g74kjhg']
    },
    sensitiveType: {
        0: i18n.messages[str].language['5o6u1gm4kjhg'],
        1: i18n.messages[str].language['5o6u1gm4k0hg'],
        2: i18n.messages[str].language['5o6u1ga4kjhg'],
        3: i18n.messages[str].language['5o6u1gm4kshg'],
        4: i18n.messages[str].language['1o6u1gm4kjhg'],
        5: i18n.messages[str].language['5o6u1gm4kahg'],
        6: i18n.messages[str].language['5o6u1g84kjhg'],
        7: i18n.messages[str].language['5o6u1gm4kj4g']
    },
    dids: {
        1: i18n.messages[str].language['5o6u1gm4kjh1'],
        2: i18n.messages[str].language['526u1gm4kjhg']
    },
    didList: [{
        label: i18n.messages[str].language['5o6u1gm4kjh1'],
        value: 1
    }, {
        label: i18n.messages[str].language['526u1gm4kjhg'],
        value: 2
    }]
}
